import { Component, input } from '@angular/core';
import { AiToolHeaderForm, AiToolHeaderFormArray } from '../../../core/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FunctionHeader } from '@vendasta/protos/ai_assistants/v1alpha1';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'ai-tool-header-form-array',
  imports: [
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './ai-tool-header-form-array.component.html',
})
export class AiToolHeaderFormArrayComponent {
  readonly forms = input.required<AiToolHeaderFormArray>();

  protected readonly commonHeaderOptions = [
    { label: 'Content-Type: JSON', header: { key: 'Content-Type', value: 'application/json' } },
    { label: 'Accept: JSON', header: { key: 'Accept', value: 'application/json' } },
    { label: 'Authorization', header: { key: 'Authorization', value: '' } },
  ];

  handleAdd(header?: FunctionHeader) {
    this.forms().push(new AiToolHeaderForm(header));
  }

  handleRemove(index: number) {
    this.forms().removeAt(index);
  }

  protected isAuthorizationHeader(form: AiToolHeaderForm): boolean {
    return form.controls.name.getRawValue()?.toLowerCase() === 'authorization';
  }
}
